(function() { window.GUID_2a3104cb_6550_4879_b727_58ada488afdb = { getGuid: function() { return "2a3104cb-6550-4879-b727-58ada488afdb"; } }; })();
//Generated using Copilot :
//The function ShareFacebookClicked was used to generate the following wrapper NA_ShareFacebookClicked.  I want you to generate the wrappers for the functions after the comment, the content of the wrapper is the same as the content in NA_ShareFacebookClicked, but replace ShareFacebookClicked with the name of the current function.  Do not use dynamic javascript
/*
    declare function ShareFacebookClicked(shareUrl: string);
    export function NA_ShareFacebookClicked(shareUrl: string){
        if (typeof ShareFacebookClicked == 'undefined') {
            CS.Analytics.Error('ShareFacebookClicked not defined', 'NativeApp Proxy');
            return false;
        }
        ShareFacebookClicked(shareUrl);
        return true;
    }
    */
var CS;
(function (CS) {
    var NativeApp;
    (function (NativeApp) {
        function NativeScriptVersion() {
            return '1.0.4';
        }
        NativeApp.NativeScriptVersion = NativeScriptVersion;
        function NA_SignupFacebookClicked(facebookLoginUrl) {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('SignupFacebookClicked', facebookLoginUrl);
                return true;
            }
            else if (typeof SignupFacebookClicked == 'undefined') {
                CS.Analytics.Error('SignupFacebookClicked not defined', 'NativeApp Proxy');
                return false;
            }
            SignupFacebookClicked(facebookLoginUrl);
            return true;
        }
        NativeApp.NA_SignupFacebookClicked = NA_SignupFacebookClicked;
        function NA_SignupAppleClicked(appleLoginUrl) {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('SignupAppleClicked', appleLoginUrl);
                return true;
            }
            else if (typeof SignupAppleClicked == 'undefined') {
                CS.Analytics.Error('SignupAppleClicked not defined', 'NativeApp Proxy');
                return false;
            }
            SignupAppleClicked(appleLoginUrl);
            return true;
        }
        NativeApp.NA_SignupAppleClicked = NA_SignupAppleClicked;
        function NA_SignupGoogleClicked(googleLoginUrl) {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('SignupGoogleClicked', googleLoginUrl);
                return true;
            }
            else if (typeof SignupGoogleClicked == 'undefined') {
                CS.Analytics.Error('SignupGoogleClicked not defined', 'NativeApp Proxy');
                return false;
            }
            SignupGoogleClicked(googleLoginUrl);
            return true;
        }
        NativeApp.NA_SignupGoogleClicked = NA_SignupGoogleClicked;
        function NA_LinkFacebookClicked(password) {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('LinkFacebookClicked', password);
                return true;
            }
            else if (typeof LinkFacebookClicked == 'undefined') {
                CS.Analytics.Error('LinkFacebookClicked not defined', 'NativeApp Proxy');
                return false;
            }
            LinkFacebookClicked(password);
            return true;
        }
        NativeApp.NA_LinkFacebookClicked = NA_LinkFacebookClicked;
        function NA_ShareFacebookClicked(shareUrl) {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('ShareFacebookClicked', shareUrl);
                return true;
            }
            else if (typeof ShareFacebookClicked == 'undefined') {
                CS.Analytics.Error('ShareFacebookClicked not defined', 'NativeApp Proxy');
                return false;
            }
            ShareFacebookClicked(shareUrl);
            return true;
        }
        NativeApp.NA_ShareFacebookClicked = NA_ShareFacebookClicked;
        function NA_RequestDeviceToken() {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('RequestDeviceToken');
                return true;
            }
            else if (typeof RequestDeviceToken == 'undefined') {
                CS.Analytics.Error('RequestDeviceToken not defined', 'NativeApp Proxy');
                return false;
            }
            RequestDeviceToken();
            return true;
        }
        NativeApp.NA_RequestDeviceToken = NA_RequestDeviceToken;
        function NA_TakePicture(returnUrl) {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('TakePicture', returnUrl);
                return true;
            }
            else if (typeof TakePicture == 'undefined') {
                CS.Analytics.Error('TakePicture not defined', 'NativeApp Proxy');
                return false;
            }
            TakePicture(returnUrl);
            return true;
        }
        NativeApp.NA_TakePicture = NA_TakePicture;
        function NA_SelectPicture(returnUrl) {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('SelectPicture', returnUrl);
                return true;
            }
            else if (typeof SelectPicture == 'undefined') {
                CS.Analytics.Error('SelectPicture not defined', 'NativeApp Proxy');
                return false;
            }
            SelectPicture(returnUrl);
            return true;
        }
        NativeApp.NA_SelectPicture = NA_SelectPicture;
        function NA_RequestReview() {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('RequestReview');
                return true;
            }
            else if (typeof RequestReview == 'undefined') {
                CS.Analytics.Error('RequestReview not defined', 'NativeApp Proxy');
                return false;
            }
            RequestReview();
            return true;
        }
        NativeApp.NA_RequestReview = NA_RequestReview;
        function NA_OpenReviewPage() {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('OpenReviewPage');
                return true;
            }
            else if (typeof OpenReviewPage == 'undefined') {
                CS.Analytics.Error('OpenReviewPage not defined', 'NativeApp Proxy');
                return false;
            }
            OpenReviewPage();
            return true;
        }
        NativeApp.NA_OpenReviewPage = NA_OpenReviewPage;
        function NA_OpenSettingsApp() {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('OpenSettingsApp');
                return true;
            }
            else if (typeof OpenSettingsApp == 'undefined') {
                CS.Analytics.Error('OpenSettingsApp not defined', 'NativeApp Proxy');
                return false;
            }
            OpenSettingsApp();
            return true;
        }
        NativeApp.NA_OpenSettingsApp = NA_OpenSettingsApp;
        function NA_OpenSettingsBattery() {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('OpenSettingsBattery');
                return true;
            }
            else if (typeof OpenSettingsBattery == 'undefined') {
                CS.Analytics.Error('OpenSettingsBattery not defined', 'NativeApp Proxy');
                return false;
            }
            OpenSettingsBattery();
            return true;
        }
        NativeApp.NA_OpenSettingsBattery = NA_OpenSettingsBattery;
        function NA_OpenSettingsNotifications() {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('OpenSettingsNotifications');
                return true;
            }
            else if (typeof OpenSettingsNotifications == 'undefined') {
                CS.Analytics.Error('OpenSettingsNotifications not defined', 'NativeApp Proxy');
                return false;
            }
            OpenSettingsNotifications();
            return true;
        }
        NativeApp.NA_OpenSettingsNotifications = NA_OpenSettingsNotifications;
        function NA_ChangeDebugBaseUrl(newBaseUrl) {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('ChangeDebugBaseUrl', newBaseUrl);
                return true;
            }
            else if (typeof ChangeDebugBaseUrl == 'undefined') {
                CS.Analytics.Error('ChangeDebugBaseUrl not defined', 'NativeApp Proxy');
                return false;
            }
            ChangeDebugBaseUrl(newBaseUrl);
            return true;
        }
        NativeApp.NA_ChangeDebugBaseUrl = NA_ChangeDebugBaseUrl;
        function NA_ShowHeader(height) {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('ShowHeader', height.toString());
                return true;
            }
            else if (typeof ShowHeader == 'undefined') {
                CS.Analytics.Error('ShowHeader not defined', 'NativeApp Proxy');
                return false;
            }
            ShowHeader(height);
            return true;
        }
        NativeApp.NA_ShowHeader = NA_ShowHeader;
        function NA_AskForNotifications() {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('AskForNotifications');
                return true;
            }
            else if (typeof AskForNotifications == 'undefined') {
                CS.Analytics.Error('AskForNotifications not defined', 'NativeApp Proxy');
                return false;
            }
            AskForNotifications();
            return true;
        }
        NativeApp.NA_AskForNotifications = NA_AskForNotifications;
        function NA_OpenExternalLink(url) {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('OpenExternalLink', url);
                return true;
            }
            else if (typeof OpenExternalLink == 'undefined') {
                CS.Analytics.Error('OpenExternalLink not defined', 'NativeApp Proxy');
                return false;
            }
            OpenExternalLink(url);
            return true;
        }
        NativeApp.NA_OpenExternalLink = NA_OpenExternalLink;
        function NA_ErrorShow(isVisible) {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('ErrorShow', isVisible);
                return true;
            }
            else if (typeof ErrorShow == 'undefined') {
                CS.Analytics.Error('ErrorShow not defined', 'NativeApp Proxy');
                return false;
            }
            ErrorShow(isVisible);
            return true;
        }
        NativeApp.NA_ErrorShow = NA_ErrorShow;
        function NA_SlowNavigationRaised() {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('SlowNavigationRaised');
                return true;
            }
            else if (typeof SlowNavigationRaised == 'undefined') {
                CS.Analytics.Error('SlowNavigationRaised not defined', 'NativeApp Proxy');
                return false;
            }
            SlowNavigationRaised();
            return true;
        }
        NativeApp.NA_SlowNavigationRaised = NA_SlowNavigationRaised;
        function NA_LoadFullscreenAd(adId) {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('LoadFullscreenAd', adId);
                return true;
            }
            else if (typeof LoadFullscreenAd == 'undefined') {
                CS.Analytics.Error('LoadFullscreenAd not defined', 'NativeApp Proxy');
                return false;
            }
            LoadFullscreenAd(adId);
            return true;
        }
        NativeApp.NA_LoadFullscreenAd = NA_LoadFullscreenAd;
        function NA_ShowFullscreenAd(showIfNotLoaded) {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('ShowFullscreenAd', showIfNotLoaded);
                return true;
            }
            else if (typeof ShowFullscreenAd == 'undefined') {
                CS.Analytics.Error('ShowFullscreenAd not defined', 'NativeApp Proxy');
                return false;
            }
            ShowFullscreenAd(showIfNotLoaded);
            return true;
        }
        NativeApp.NA_ShowFullscreenAd = NA_ShowFullscreenAd;
        function NA_LoadRewardAd(adId) {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('LoadRewardAd', adId);
                return true;
            }
            else if (typeof LoadRewardAd == 'undefined') {
                CS.Analytics.Error('LoadRewardAd not defined', 'NativeApp Proxy');
                return false;
            }
            LoadRewardAd(adId);
            return true;
        }
        NativeApp.NA_LoadRewardAd = NA_LoadRewardAd;
        function NA_ShowRewardAd(showIfNotLoaded) {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('ShowRewardAd', showIfNotLoaded);
                return true;
            }
            else if (typeof ShowRewardAd == 'undefined') {
                CS.Analytics.Error('ShowRewardAd not defined', 'NativeApp Proxy');
                return false;
            }
            ShowRewardAd(showIfNotLoaded);
            return true;
        }
        NativeApp.NA_ShowRewardAd = NA_ShowRewardAd;
        function NA_TestWebApi() {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('TestWebApi');
                return true;
            }
            else if (typeof TestWebApi == 'undefined') {
                CS.Analytics.Error('TestWebApi not defined', 'NativeApp Proxy');
                return false;
            }
            TestWebApi();
            return true;
        }
        NativeApp.NA_TestWebApi = NA_TestWebApi;
        function NA_SendTestNotification() {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('SendTestNotification');
                return true;
            }
            else if (typeof SendTestNotification == 'undefined') {
                CS.Analytics.Error('SendTestNotification not defined', 'NativeApp Proxy');
                return false;
            }
            SendTestNotification();
            return true;
        }
        NativeApp.NA_SendTestNotification = NA_SendTestNotification;
        function NA_SendLogFile() {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('SendLogFile');
                return true;
            }
            else if (typeof SendLogFile == 'undefined') {
                CS.Analytics.Error('SendLogFile not defined', 'NativeApp Proxy');
                return false;
            }
            SendLogFile();
            return true;
        }
        NativeApp.NA_SendLogFile = NA_SendLogFile;
        function NA_DisableRefresh() {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('DisableRefresh');
                return true;
            }
            else if (typeof DisableRefresh == 'undefined') {
                CS.Analytics.Error('DisableRefresh not defined', 'NativeApp Proxy');
                return false;
            }
            DisableRefresh();
            return true;
        }
        NativeApp.NA_DisableRefresh = NA_DisableRefresh;
        function NA_OpenFile(jsonString) {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('OpenFile', jsonString);
                return true;
            }
            else if (typeof OpenFile == 'undefined') {
                CS.Analytics.Error('OpenFile not defined', 'NativeApp Proxy');
                return false;
            }
            OpenFile(jsonString);
            return true;
        }
        NativeApp.NA_OpenFile = NA_OpenFile;
        function NA_AskStreamingPermissions(jsonString) {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('AskStreamingPermissions', jsonString);
                return true;
            }
            else if (typeof AskStreamingPermissions == 'undefined') {
                CS.Analytics.Error('AskStreamingPermissions not defined', 'NativeApp Proxy');
                return false;
            }
            AskStreamingPermissions(jsonString);
            return true;
        }
        NativeApp.NA_AskStreamingPermissions = NA_AskStreamingPermissions;
        function NA_CheckStreamingPermissions(serviceName) {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('CheckStreamingPermissions', serviceName);
                return true;
            }
            else if (typeof CheckStreamingPermissions == 'undefined') {
                CS.Analytics.Error('CheckStreamingPermissions not defined', 'NativeApp Proxy');
                return false;
            }
            CheckStreamingPermissions(serviceName);
            return true;
        }
        NativeApp.NA_CheckStreamingPermissions = NA_CheckStreamingPermissions;
        function NA_SetUserDeviceCompleted(userDeviceId) {
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('SetUserDeviceCompleted', userDeviceId);
                return true;
            }
            else if (typeof SetUserDeviceCompleted == 'undefined') {
                CS.Analytics.Error('SetUserDeviceCompleted not defined', 'NativeApp Proxy');
                return false;
            }
            SetUserDeviceCompleted(userDeviceId);
            return true;
        }
        NativeApp.NA_SetUserDeviceCompleted = NA_SetUserDeviceCompleted;
        function NA_SetUserDeviceCompletedV2(json) {
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('SetUserDeviceCompletedV2', json);
                return true;
            }
            else if (typeof SetUserDeviceCompletedV2 == 'undefined') {
                return false;
            }
            SetUserDeviceCompletedV2(json);
            return true;
        }
        NativeApp.NA_SetUserDeviceCompletedV2 = NA_SetUserDeviceCompletedV2;
        function NA_ScanQrCode() {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('ScanQrCode');
                return true;
            }
            else if (typeof ScanQrCode == 'undefined') {
                CS.Analytics.Error('ScanQrCode not defined', 'NativeApp Proxy');
                return false;
            }
            ScanQrCode();
            return true;
        }
        NativeApp.NA_ScanQrCode = NA_ScanQrCode;
        function NA_GetCurrentPosition() {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('GetCurrentPosition');
                return true;
            }
            else if (typeof GetCurrentPosition == 'undefined') {
                CS.Analytics.Error('GetCurrentPosition not defined', 'NativeApp Proxy');
                return false;
            }
            GetCurrentPosition();
            return true;
        }
        NativeApp.NA_GetCurrentPosition = NA_GetCurrentPosition;
        function NA_AppleGetCurrentPosition() {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('AppleGetCurrentPosition');
                return true;
            }
            else if (typeof AppleGetCurrentPosition == 'undefined') {
                CS.Analytics.Error('AppleGetCurrentPosition not defined', 'NativeApp Proxy');
                return false;
            }
            AppleGetCurrentPosition();
            return true;
        }
        NativeApp.NA_AppleGetCurrentPosition = NA_AppleGetCurrentPosition;
        function NA_Navigated(url) {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('Navigated', url);
                return true;
            }
            else if (typeof Navigated == 'undefined') {
                CS.Analytics.Error('Navigated not defined', 'NativeApp Proxy');
                return false;
            }
            Navigated(url);
            return true;
        }
        NativeApp.NA_Navigated = NA_Navigated;
        function NA_Navigating(url) {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('Navigating', url);
                return true;
            }
            else if (typeof Navigating == 'undefined') {
                CS.Analytics.Error('Navigating not defined', 'NativeApp Proxy');
                return false;
            }
            Navigating(url);
            return true;
        }
        NativeApp.NA_Navigating = NA_Navigating;
        function NA_NoInternetConnection() {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('NoInternetConnection');
                return true;
            }
            else if (typeof NoInternetConnection == 'undefined') {
                CS.Analytics.Error('NoInternetConnection not defined', 'NativeApp Proxy');
                return false;
            }
            NoInternetConnection();
            return true;
        }
        NativeApp.NA_NoInternetConnection = NA_NoInternetConnection;
        function NA_NavigationError(type) {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('NavigationError', type);
                return true;
            }
            else if (typeof NavigationError == 'undefined') {
                CS.Analytics.Error('NavigationError not defined', 'NativeApp Proxy');
                return false;
            }
            NavigationError(type);
            return true;
        }
        NativeApp.NA_NavigationError = NA_NavigationError;
        function NA_PurchaseConsumable(purchaseItem) {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('PurchaseConsumable', purchaseItem);
                return true;
            }
            else if (typeof PurchaseConsumable == 'undefined') {
                CS.Analytics.Error('PurchaseConsumable not defined', 'NativeApp Proxy');
                return false;
            }
            PurchaseConsumable(purchaseItem);
            return true;
        }
        NativeApp.NA_PurchaseConsumable = NA_PurchaseConsumable;
        function NA_PurchaseSubscription(purchaseItem) {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('PurchaseSubscription', purchaseItem);
                return true;
            }
            else if (typeof PurchaseSubscription == 'undefined') {
                CS.Analytics.Error('PurchaseSubscription not defined', 'NativeApp Proxy');
                return false;
            }
            PurchaseSubscription(purchaseItem);
            return true;
        }
        NativeApp.NA_PurchaseSubscription = NA_PurchaseSubscription;
        function NA_UpdateSubscription(purchaseItem) {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('UpdateSubscription', purchaseItem);
                return true;
            }
            else if (typeof UpdateSubscription == 'undefined') {
                CS.Analytics.Error('UpdateSubscription not defined', 'NativeApp Proxy');
                return false;
            }
            UpdateSubscription(purchaseItem);
            return true;
        }
        NativeApp.NA_UpdateSubscription = NA_UpdateSubscription;
        function NA_RestoreSubscription() {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('RestoreSubscription');
                return true;
            }
            else if (typeof RestoreSubscription == 'undefined') {
                CS.Analytics.Error('RestoreSubscription not defined', 'NativeApp Proxy');
                return false;
            }
            RestoreSubscription();
            return true;
        }
        NativeApp.NA_RestoreSubscription = NA_RestoreSubscription;
        function NA_ShowNativeDebugInfo(text) {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('ShowNativeDebugInfo', text);
                return true;
            }
            else if (typeof ShowNativeDebugInfo == 'undefined') {
                CS.Analytics.Error('ShowNativeDebugInfo not defined', 'NativeApp Proxy');
                return false;
            }
            ShowNativeDebugInfo(text);
            return true;
        }
        NativeApp.NA_ShowNativeDebugInfo = NA_ShowNativeDebugInfo;
        function NA_AskFacebookStreamingPermissions() {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('AskFacebookStreamingPermissions');
                return true;
            }
            return false;
        }
        NativeApp.NA_AskFacebookStreamingPermissions = NA_AskFacebookStreamingPermissions;
        function NA_FacebookStreaming(jsonString) {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('FacebookStreaming', jsonString);
                return true;
            }
            else if (typeof FacebookStreaming == 'undefined') {
                CS.Analytics.Error('FacebookStreaming not defined', 'NativeApp Proxy');
                return false;
            }
            FacebookStreaming(jsonString);
            return true;
        }
        NativeApp.NA_FacebookStreaming = NA_FacebookStreaming;
        function NA_YouTubeStreaming(jsonString) {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('YouTubeStreaming', jsonString);
                return true;
            }
            else if (typeof YouTubeStreaming == 'undefined') {
                CS.Analytics.Error('YouTubeStreaming not defined', 'NativeApp Proxy');
                return false;
            }
            YouTubeStreaming(jsonString);
            return true;
        }
        NativeApp.NA_YouTubeStreaming = NA_YouTubeStreaming;
        function NA_EnableWebDev() {
            var _a, _b;
            if (!((_b = (_a = CS === null || CS === void 0 ? void 0 : CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.IsNativeApp))
                return false;
            if (typeof window.HybridWebView !== 'undefined' && window.HybridWebView != null) {
                window.HybridWebView.SendInvokeMessageToDotNet('EnableWebDev');
                return true;
            }
            else if (typeof EnableWebDev == 'undefined') {
                CS.Analytics.Error('EnableWebDev not defined', 'NativeApp Proxy');
                return false;
            }
            EnableWebDev();
            return true;
        }
        NativeApp.NA_EnableWebDev = NA_EnableWebDev;
    })(NativeApp = CS.NativeApp || (CS.NativeApp = {}));
})(CS || (CS = {}));

//# sourceMappingURL=cs-nativeapp.js.map
